<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单明细
  -->
  <div class="pb50">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">订单明细</div>
      <div class="table-wrap" v-if="detail.scale_json.data">
        <el-row>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">平台所得分佣：</span>
              {{ detail.scale_json.data.sys_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">一级用户所得分佣</span>
              {{ detail.scale_json.data.user_promotion_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">二级用户所得分佣：</span>
              {{ detail.scale_json.data.two_user_promotion_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">1级技师推广所得分佣：</span>
              {{ detail.scale_json.data.waiter_promotion_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">2级技师推广所得分佣：</span>
              {{ detail.scale_json.data.waiter_promotion_price || 0 }}
            </div>
          </el-col>

          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">商户所得分佣：</span>
              {{ detail.scale_json.data.supplier_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">技师所得分佣(不含车费)：</span>
              {{ detail.scale_json.data.waiter_price  || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">会员优惠所有人承担：</span>
              {{ detail.scale_json.data.vip_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">储值扣款：</span>
              {{ detail.scale_json.data.stored_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">提现手续费：</span>
              {{ detail.scale_json.data.handling_price || 0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">服务费：</span>
              {{ detail.scale_json.data.service_price || 0 }}
            </div>
          </el-col>

          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">渠道用户：</span>
              {{ detail.scale_json.data.channel_user || 0 }}
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  // props: ["detail"],
  inject: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      scale_json: {}
    };
  },
  created() {
    console.log(this.detail,'92222')
    // this.scale_json=this.detail.scale_json.data
      // if (self.detail.scale) {
      //   self.scale_json = JSON.parse(self.detail.scale);
      //   console.log(self.scale_json, 9191);

      // }

    /*获取列表*/
    // this.getParams();
  },
  methods: {
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.orderId;
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(data => {
          console.log(data);
          self.loading = false;
          self.detail = data.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/part/detail.vue